// @flow
import React from 'react';

import CardThumbnail from 'components/fragments/card/CardThumbnail';
import type { BlocFaq } from 'types/Settings';

export type StateProps = {
  blocs_faq: Array<BlocFaq>
};

type Props = StateProps;

function ContactThumbnailsBlock({ blocs_faq }: Props) {
  // $FlowFixMe
  return blocs_faq.map(thumbnail => {
    let url = '';

    if (thumbnail.parent_slugs[1]) {
      url = `${thumbnail.parent_slugs[1]}/`;
    }

    if (thumbnail.parent_slugs[2]) {
      url = `${url}${thumbnail.parent_slugs[2]}/`;
    }

    url = `${url}${thumbnail.object_slug}`;

    // https://www.codementor.io/blog/react-optimization-5wiwjnf9hj#9-avoid-using-index-as-key-for-map
    return (
      <div key={thumbnail.title} className="col col-md-4 col-lg-4 mb-2 mb-md-4 mb-lg-4">
        <CardThumbnail
          url={`/${url}`}
          backgroundUrl={thumbnail.featured_image}
          title={thumbnail.title}
          desc={thumbnail.description}
          linkLabel={thumbnail.texte_cta}
        />
      </div>
    );
  });
}

export default ContactThumbnailsBlock;
